module.exports = __webpack_public_path__ + "fonts/effect-health-5d3fd0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-health.svg
// module id = 771
// module chunks = 0